<template>
  <div class="component-fullscreen"  @click="click">
    <i :class="['icon iconfont-ec-theme ', isFullscreen?'icon-fullscreen':'icon-exit-fullscreen']"></i>
  </div>
</template>

<script>
import screenfull from 'screenfull'

export default {
  name: 'EcScreenfull',
  data() {
    return {
      isFullscreen: false
    }
  },
  props: {
    target: String
  },
  mounted() {
    this.init()
  },
  beforeDestroy() {
    this.destroy()
  },
  methods: {
    click() {
      if (!screenfull.isEnabled) {
        this.$message({
          message: '您的浏览器不支持',
          type: 'warning'
        })
        return false
      }
      let oTarget = this.target && document.getElementById(this.target)
      screenfull.toggle(oTarget)
    },
    change() {
      this.isFullscreen = screenfull.isFullscreen
      this.$emit('handleFullscreen', this.isFullscreen)
    },
    init() {
      if (screenfull.isEnabled) {
        screenfull.on('change', this.change)
      }
    },
    destroy() {
      if (screenfull.isEnabled) {
        screenfull.off('change', this.change)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.component-fullscreen {
    width: 25px;
    height: 25px;
    text-align: center;
    line-height: 25px;
    border-radius: 100%;
    color: #fff;
  &:hover {
    cursor: pointer;
    box-shadow: 10px 0 0 #61d5ee;
    box-shadow: 0 0 3px 2px #61d5ee;
    border-radius: 100%;
  }
}
.common-fullscreen,
.exit-fullscreen {
  border-radius: 100%;
  font-size: 16px;
  text-align: center;
  background: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/EcScreenfull/src/index.vue